import { GoogleOAuthProvider } from '@react-oauth/google';
import {
  AuthProvider,
  Modals,
  ThemeProvider,
  Toaster,
  TranslationProvider,
} from '@supsupclub/ui-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { SettingsDrawer } from './user/components/settings-drawer';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <GoogleOAuthProvider clientId={googleClientId}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <TranslationProvider>
              <App />
              <Modals />
              <SettingsDrawer />
              <Toaster />
            </TranslationProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </GoogleOAuthProvider>,
);
